import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import { PlcGrid } from "./types";

import Source from "./components/Source";
import SourceMetric from "./components/SourceMetric";


interface IProps {
  data: PlcGrid;
}


const SourceGrid: FunctionComponent<IProps> = memo(function SourceGrid({
  data,
}) {
  const intl = useIntl();

  return <>
    <Source
      name={intl.formatMessage({
        id: "site__control__grid__name",
        defaultMessage: "Grid",
      })}
      outOfBounds={data?.target.kw_control_power_drift !== 0}
      offline={!data}
      {...data}
    >
      {data && <>
      <SourceMetric
        secondary
        name={intl.formatMessage({
          id: "site__control__grid__frequency",
          defaultMessage: "Frequency",
        })}
        value={data.metrics?.hz_frequency}
        decimals={2}
        unit="Hz"
      />
      <SourceMetric
        name={intl.formatMessage({
          id: "site__control__grid__site_power",
          defaultMessage: "Site consumption",
        })}
        value={data.metrics?.kw_site_power}
        unit="kW"
      />
      <SourceMetric
        name={intl.formatMessage({
          id: "site__control__grid__reactive_power",
          defaultMessage: "Reactive power",
        })}
        value={data.metrics?.kvar_reactive_power}
        unit="kVAR"
      />
      </>}
    </Source>
  </>
}, isEqual);

export default SourceGrid;
